'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var range = function range(min, max) {
  return Array.apply(null, { length: max - min + 1 }).map(function (v, i) {
    return i + min;
  });
};

exports.default = function (level, label, events) {
  var chart = { level: level, label: label, events: events };

  chart.rows = [];

  /*
   * Store sorted distinct age values (not buckets). These are chart columns.
   */
  chart.ages = chart.events
  // First convert brackets to ranges of ages.
  .map(function (event) {
    var min = event.get('age_min');
    var max = event.get('age_max');

    if (!max) {
      return [min];
    } else if (!min) {
      return [max];
    } else {
      return range(min, max);
    }
  })

  // Flatten and limit the ages to unique values.
  .reduce(function (arr, val) {
    val.forEach(function (num) {
      if (arr.indexOf(num) === -1) {
        arr.push(num);
      }
    });

    return arr;
  }, [])

  // Put them in ascending order.
  .sort(function (a, b) {
    return a - b;
  });

  var ageMin = chart.ages[0];
  var ageMax = chart.ages[chart.ages.length - 1];

  /*
   * Store distinct labels. These are chart rows.
   */
  chart.labels = chart.events.map(function (ev) {
    return ev.get('event');
  }).reduce(function (arr, label) {
    if (arr.indexOf(label) === -1) {
      arr.push(label);
    }

    return arr;
  }, [])

  // Sort rows by label alphabetically.
  .sort()

  // Map to an object so we can store more data.
  .map(function (label) {
    return { label: label, rows: [] };
  });

  /*
   * Create rows of events spanning age columns within each label. Because ages can overlap, there
   * may be multiple rows per label.
   */
  chart.labels.forEach(function (label) {
    // Get events for this label.
    label.events = chart.events.filter(function (ev) {
      return ev.get('event') === label.label;
    })

    // Sort by min age ascending, max age descending. E.g. we'll start rows with the
    // lowest-reaching age values. In the event of an overlap, we give order precedence to the
    // broadest range of numbers. In addition, we can add left column offsets to events to ensure
    // correct column positioning within the rows if events are always filled left to right.
    .sort(function (a, b) {
      var ageStartA = a.get('age_min') || ageMin;
      var ageEndA = a.get('age_max') || ageMax;
      var ageStartB = b.get('age_min') || ageMin;
      var ageEndB = b.get('age_max') || ageMax;

      return ageStartA - ageStartB || ageEndB - ageEndA;
    });

    // Assign each event within this label to a display row. Since they can overlap columns, we
    // ensure no overlapping values per age.
    label.events.forEach(function (ev) {
      // Set the correct span for the cell. This is the max - min ages. If either is unbounded, we
      // use the highest or lowest chart ages, respectively, so they will span to the end of the
      // row. However, we do not list empty age groups, so filter values missing from the chart's
      // age list.
      var ageStart = ev.get('age_min') || ageMin;
      var ageEnd = ev.get('age_max') || ageMax;
      var eventAges = range(ageStart, ageEnd).filter(function (age) {
        return chart.ages.indexOf(age) !== -1;
      });

      var cell = {
        event: ev,
        span: eventAges.length,
        start: ageStart
      };

      // Find first row with no overlapping ages, inclusive of unbounded brackets
      var row = label.rows.find(function (row) {
        return eventAges.every(function (k) {
          return !row.metadata[k];
        });
      });

      // If no available row was found, create a new one.
      if (!row) {
        row = {
          metadata: {},
          events: []
        };

        label.rows.push(row);
      }

      // For all ages directly preceeding the minimum age of this event, add an offset to this event
      // to ensure it is positioned starting at the correct column.
      var placeholderSpan = 0;
      var placeholderMin = 0;
      var placeholderMax = 0;
      chart.ages.filter(function (age) {
        return age < ageStart;
      }).reverse().every(function (age) {
        // First taken value and we're done.
        if (row.metadata[age]) {
          return false;
        }

        // Otherwise, we need to offset this empty cell by inserting a placeholder.
        placeholderSpan = placeholderSpan + 1;
        placeholderMin = age;
        placeholderMax = age > placeholderMax ? age : placeholderMax;
        return true;
      });

      if (placeholderSpan > 0) {
        row.events.push({
          $placeholder: {
            age_min: placeholderMin,
            age_max: placeholderMax,
            event: label.label,
            level: chart.level
          },
          span: placeholderSpan
        });
      }

      // Add the event to the row.
      row.events.push(cell);

      // Update row metadata to mark ages as covered.
      eventAges.forEach(function (age) {
        return row.metadata[age] = true;
      });
    });

    // Now that all events are on the chart, we need to go through and add all the placeholders that
    // at the end of the chart. While creating an event, we covered all others.
    label.rows.forEach(function (row, idx) {
      var placeholderSpan = 0;
      var placeholderMin = 0;
      var placeholderMax = 0;

      [].concat(chart.ages).reverse().every(function (age) {
        // First taken value and we're done.
        if (row.metadata[age]) {
          return false;
        }

        // Otherwise, we need to offset this empty cell by inserting a placeholder.
        placeholderSpan = placeholderSpan + 1;
        placeholderMin = age;
        placeholderMax = age > placeholderMax ? age : placeholderMax;
        return true;
      });

      if (placeholderSpan > 0) {
        row.events.push({
          $placeholder: {
            age_min: placeholderMin,
            age_max: placeholderMax,
            event: label.label,
            level: chart.level
          },
          span: placeholderSpan
        });
      }
    });
  });

  return (0, _immutable.fromJS)(chart);
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/create-chart.js
// module id = 575
// module chunks = 0